import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default to localStorage for web
import rootReducer from './reducers'; // Assumes you have a rootReducer combining all your slices

const persistConfig = {
  key: 'wms-f6c1ed5f-3054-40e0-be40-f519cc8ecb51',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
